// Currency formatting for Mobile Xpressed (Indonesian Rupiah)

const IDR_FORMATTER = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Format a numeric price as Indonesian Rupiah — e.g. 450000 → "Rp 450.000"
 */
export function formatIDR(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "Rp 0";
  // Intl outputs "Rp450.000" without a space — normalize to "Rp 450.000"
  return IDR_FORMATTER.format(Math.round(n)).replace(/^Rp\s?/, "Rp ");
}

/**
 * Format a raw Indonesian phone-number digit string into readable groups of
 * 4 for display — e.g. "081234567890" → "0812-3456-7890"
 */
export function formatPhoneID(digits) {
  const d = String(digits || "").replace(/\D/g, "");
  return d.replace(/(\d{4})(?=\d)/g, "$1-");
}

/** Strip everything but digits, e.g. for storing/submitting a phone number. */
export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}
